import React from 'react';

const PageNotFound = () => {
  return (
    <div style={styles.container}>
      <h1>404 Page Not Found</h1>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Set the height of the container to the full viewport height
    backgroundColor:'#EDF6F0',
  },
};

export default PageNotFound;
